import PublicBuill from './publicBuill.js'
import examineTemplate from '../examineTemplate'
import billTitleTemplate from '../billTitleTemplate'
export default {
  components: {
    examineTemplate,
    billTitleTemplate
  },
  props: {
    property: Object,
    view: String,
    AccountingReview: Boolean,
    toVoid: Boolean
  },
  data() {
    return {
      user: {},
      show: true,
      jxfybxd: {},
      bxnrArr: [],
      lcPersons: ['', '', '', '', '', '', '', '', '', ''], // 流程人员
      lcPersonsName: ['', '', '', '', '', '', '', '', '', ''], // 流程名称
      optionsFyBxnr: [],
      optionsFyBxUser: [],
      examineTemplate: {
        workflowData: []
      },
      /* 审核需要数据 */
      oaSqdSh: {
        userNo: localStorage.getItem('userNo'),
        isAgree: '',
        shyj: '',
        documentType: '',
        flowId: '',
        maindjh: '',
        lb: '',
        shr: localStorage.getItem('userName'),
        shrNo: localStorage.getItem('userNo'),
        shje: ''
      },
      saveUrl: '',
      jeDx: '',
      jeXx: '',
      title: ''

    }
  },
  mounted() {
    this.initData(this.property)
  },
  created() {
    PublicBuill.setThis(this)
  },
  methods: {
    initData(billDataAll) {
      const jxfybxd = billDataAll.BillData
      this.user = localStorage

      this.jxfybxd = jxfybxd
      /* 审核使用字段 */
      this.oaSqdSh.maindjh = jxfybxd.djh
      this.oaSqdSh.flowId = jxfybxd.flowId
      this.oaSqdSh.shje = jxfybxd.je
      this.jxfybxd.lrrId = localStorage.getItem('userNo')

      /* 页面数据类型转换 */
      this.jeDx = PublicBuill.convertCurrency(jxfybxd.je)
      this.jeXx = PublicBuill.formatAmount(jxfybxd.je)
      this.jxfybxd.rq = this.jxfybxd.rq.split(' ')[0]
      /* 报销内容类型转换 */
      for (let i = 1; i <= 10; i++) {
        const bxnr = 'bxnr' + i
        const bxje = 'bxje' + i
        if (jxfybxd[bxnr].trim() !== '' && jxfybxd[bxnr]) {
          const item = {
            bxnr: jxfybxd[bxnr],
            bxje: jxfybxd[bxje]
          }
          this.bxnrArr.push(item)
        }
      }
      const djh = jxfybxd.djh.substring(0, 2)
      const rejected = jxfybxd.rejected === '1'
      const company = billDataAll.company
      /* 页面具体展示数据 */
      if (djh === 'JJ') {
        this.title = company + '基建项目费用报销单'
        this.oaSqdSh.documentType = 'jjxmfybxd0'
        this.oaSqdSh.lb = 'jjxmfybxd'
        this.saveUrl = rejected ? '/fesback/fybxdJm/restartWorkflow.z' : '/fesback/fybxdJm/edit.z'
        this.lcPersonsName =
          ['', '', '基建办负责人', '审核会计', '基建领导小组组长', '财务部长', '集团日常经营管理小组', '财务总监', '', '']
      } else if (djh === 'ZJ') {
        this.title = '铸锻产业园基建项目费用报销单'
        this.oaSqdSh.documentType = 'zdjjxmfybxd0'
        this.oaSqdSh.lb = 'zdjjxmfybxd'
        this.saveUrl = rejected ? '/fesback/fybxdDm/restartWorkflow.z' : '/fesback/fybxdDm/edit.z'
        this.lcPersonsName =
          ['', '', '基建办负责人', '', '项目领导小组组长', '朗盛财务', '集团基建领导小组组长', '集团财务', '', '']
      }

      this.examineTemplate.workflowData = []

      /* 工作流信息 */
      if (billDataAll.examineData) {
        for (let i = 0; i < billDataAll.examineData.length; i++) {
          const val = billDataAll.examineData[i]
          if (djh === 'JJ' && !jxfybxd.flowId) {
            const oldSH = {
              jjxmfybxd01: '基建办负责人',
              jjxmfybxd02: '审核会计',
              jjxmfybxd03: '基建领导小组组长',
              jjxmfybxd04: '财务部长',
              jjxmfybxd05: '集团日常经营管理小组',
              jjxmfybxd06: '财务总监'
            }
            val.lcName = oldSH[val.lcid]
          } else if (djh === 'ZJ' && !jxfybxd.flowId) {
            const oldSH = {
              zdjjxmfybxd01: '基建办负责人',
              zdjjxmfybxd02: '集团财务审批',
              zdjjxmfybxd03: '项目领导小组组长',
              zdjjxmfybxd04: '集团基建领导小组组长',
              zdjjxmfybxd05: '朗盛财务审核'
            }
            val.lcName = oldSH[val.lcid]
          }
          const nodeName = val.lcName
          if (nodeName === '经办人') {
            val.auditStatus = '提交'
          } else if (val.shbz === '0') {
            val.auditStatus = '退回'
          } else {
            val.auditStatus = '批准'
          }

          if (nodeName !== '经办人') {
            const receivedPersons = val.shr
            if (nodeName === '集团总裁') {
              this.lcPersons[9] = receivedPersons
            } else if (nodeName === '集团CFO') {
              this.lcPersons[8] = receivedPersons
            } else if (nodeName === '财务总监' || nodeName === '集团财务审批' || nodeName === '总经理') {
              this.lcPersons[7] = receivedPersons
            } else if (nodeName === '集团日常经营管理小组' || nodeName === '集团基建领导小组组长' || nodeName === '董事长') {
              this.lcPersons[6] = receivedPersons
            } else if (djh !== 'JJ' && (nodeName === '总会计师' || nodeName === '朗盛财务审核')) {
              this.lcPersons[5] = receivedPersons
            } else if (djh === 'JJ' && nodeName === '财务部长') {
              this.lcPersons[5] = receivedPersons
            } else if (nodeName === '基建领导小组组长' || nodeName === '项目领导小组组长' || nodeName === '副总经理') {
              this.lcPersons[4] = receivedPersons
            } else if ((djh === 'JJ' && nodeName === '审核会计') || (djh === 'FY' && nodeName === '财务部长')) {
              this.lcPersons[3] = receivedPersons
            } else if (nodeName === '基建办负责人' || nodeName === '部门负责人') {
              this.lcPersons[2] = receivedPersons
            } else if ((nodeName === '审核会计' || nodeName === '财务审核') && djh === 'FY') {
              this.lcPersons[1] = receivedPersons
            }
          }
          if (val.shr)
            this.examineTemplate.workflowData.push(val)
          if (i === 0 && jxfybxd.recipient) {
            this.examineTemplate.workflowData.unshift({
              shr: jxfybxd.recipient,
              auditStatus: '未办理'
            })
          }
        }

      }
      /* 如果是编辑 初始化数据准备 */
      if (this.view === 'edit') {
        if (djh === 'ZJ') {
          PublicBuill.getZDBxUser() // 办理人
        } else {
          PublicBuill.getFyBxUser() // 办理人
        }
        PublicBuill.getFybxdJmBxnr()
      }
    },
    jjxmFybxdClose() {
      this.$emit('jjxmFybxdClose')
      this.show = false
    },
    agreeClick() {
      PublicBuill.agreeClick()
    },
    refuseClick() {
      PublicBuill.refuseClick()
    },
    queryBillData() {
      this.$emit('queryBillData')
      this.jjxmFybxdClose()
    },
    addBxnr() {
      const temp = {
        bxnr: '',
        bxje: ''
      }
      if (this.bxnrArr.length <= 9) {
        this.bxnrArr.push(temp)
      }
    },
    reduceBxnr() {
      if (this.bxnrArr.length > 2) {
        this.bxnrArr.pop()
        this.jeChange()
      }
    },
    jeChange() {
      let je = 0.0
      this.bxnrArr.forEach(value => {
        if (value.bxje !== null && value.bxje !== '') {
          value.bxje = parseFloat(value.bxje).toFixed(2)
          je = (parseFloat(value.bxje) + parseFloat(je)).toFixed(2)
        }
      })
      this.jxfybxd.je = je
      this.jxfybxd.tgje = je
      this.jeXx = je
      this.jeDx = PublicBuill.convertCurrency(je)
    },
    save() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      for (let index = 0; index < 10; index++) {
        const bxnr = 'bxnr' + (index + 1)
        const bxje = 'bxje' + (index + 1)
        if (index < this.bxnrArr.length) {
          this.jxfybxd[bxnr] = this.bxnrArr[index].bxnr
          if (this.bxnrArr[index].bxje === '') {
            this.bxnrArr[index].bxje = '0.00'
          }
          this.jxfybxd[bxje] = this.bxnrArr[index].bxje
        } else {
          this.jxfybxd[bxnr] = ''
          this.jxfybxd[bxje] = '0.00'
        }
      }

      this.$post(this.saveUrl, this.jxfybxd).then(response => {
        if (response.success) {
          this.$message.success(response.message)
          this.jjxmFybxdClose()
        } else {
          this.$message.error(response.message)
        }
        loading.close()
      }).catch(res => {
        loading.close()
        this.$message.error('非预期错误' + res)
      })

    },
    jkrChange(event) {

      this.jkr = event[0]
      this.jkrid = event[1]
      this.bmbm = event[2]
      this.bmmc = event[3]
    }


  }
}
